import SelectorAudioPresentation from 'components/SelectorAudio/SelectorAudioPresentation'
import SelectorAudioContainer from 'components/SelectorAudio/SelectorAudioContainer'

export default {
  Container: SelectorAudioContainer,
  Presentation: SelectorAudioPresentation,
}
